// src/components/Community.js
import React from 'react';
import colors from '../colors';
import icon from "../assets/icon_pixel.png";

function Community() {
    return (
        <section id="community" style={styles.community}>
            <h2 style={styles.heading}>Join us </h2>
            <div style={styles.links}>
                <img src={icon} alt="Community Icon" style={styles.navIcon} />
                <a
                    href="https://x.com/wisemoji"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    Twitter
                </a>
                <img src={icon} alt="Community Icon" style={styles.navIcon} />

                <a
                    href="https://t.me/wisemoji"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    Telegram
                </a>
                {/* Add more links as needed */}
            </div>
        </section>
    );
}

const styles = {
    community: {
        padding: '60px 20px',
        backgroundColor: colors.primary,
        textAlign: 'center',
    },
    heading: {
        color: colors.textLight,
    },
    links: {
        marginTop: '20px',
    },
    navIcon: {
        width: '40px',
        height: '40px',
        marginRight: '8px',
        marginTop: '2px', // Adjust this value to align the icon vertically
    },
    link: {
        margin: '0 10px',
        fontSize: '1.5rem',
        color: colors.textLight,
        textDecoration: 'underline',
    },
};

export default Community;